export default {
    indexJoinCategories:    { method: 'get',    url: 'join_categories' },
    createJoinCategory:     { method: 'post',   url: 'join_categories'},
    updateJoinCategory:     { method: 'put',    url: 'join_categories/{id}'},
    destroyJoinCategory:    { method: 'delete', url: 'join_categories/{id}'},
}